import type { IUserRepository } from '../repositories/IUserRepository.js';
import type { UserEntity } from '../entities/UserEntity.js';

interface Dependencies {
  userRepository: IUserRepository;
}

export function createGetUsersByEmailsUseCase({ userRepository }: Dependencies) {
  return async function getUsersByEmails(emails: string[]): Promise<UserEntity[]> {
    return userRepository.getByEmails(emails);
  };
}
